module.exports = __webpack_public_path__ + "img/bf50163b3594c89d2c237475af2f8f98.png";